import { throttleTimeout } from '../../common/throttleTimeout';
import { isElementOutsideWindow } from '../../viewport/is-element-outside-window';
import { BaseScrollStrategy } from './base-scroll-strategy';

export interface RepositionScrollStrategyConfig {
	scrollThrottle?: number;
	autoClose?: boolean;
}

export class RepositionScrollStrategy extends BaseScrollStrategy {
	constructor(private config?: RepositionScrollStrategyConfig) {
		super();
	}

	handleEnable() {
		window.addEventListener('scroll', this.handleScroll);
	}

	handleDisable() {
		window.removeEventListener('scroll', this.handleScroll);
	}

	private handleScroll = () => {
		const autoClose = this.config ? this.config.autoClose : true;

		throttleTimeout(this.config?.scrollThrottle || 0, () => {
			this.overlayRef.updatePosition();

			if (autoClose) {
				if (isElementOutsideWindow(this.overlayRef.overlayElement)) {
					this.disable();
					this.overlayRef.close();
				}
			}
		});
	};
}
